import { CSSObjectWithLabel } from 'react-select'

export const menuAboveStickyStyle = {
  menu: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: 1030
  })
}

export const smallStyle = {
  control: (base: CSSObjectWithLabel) => ({
    ...base,
    height: 30,
    minHeight: 30
  }),
  indicatorsContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    height: 30,
    minHeight: 30,
  }),
  valueContainer: (base: CSSObjectWithLabel) => ({
    ...base,
    height: 30,
    minHeight: 30,
  }),
  input: (base: CSSObjectWithLabel) => ({
    ...base,
    height: 22,
    minHeight: 22,
    paddingTop: 0,
    marginTop: 0,
    paddingBottom: 0,
    marginBottom: 0,
  })
}